import { Checkbox } from "@/components/ui/checkbox";
import { Download, ShieldAlert } from "lucide-react";
import { Link } from "react-router-dom";

const MUP_FILES = [
  { label: "Allegato 3 - MUP Christian Colucci", url: "https://customer-assets.emergentagent.com/job_proposta-su-misura/artifacts/22m5jqw6_Allegato%203-MUP%20CHRISTIAN%20COLUCCI.pdf" },
  { label: "Allegato 3 - MUP Ciro Colucci", url: "https://customer-assets.emergentagent.com/job_proposta-su-misura/artifacts/evgrukbx_Allegato%203-MUP%20CIRO%20COLUCCI.pdf" },
  { label: "Allegato 4 - MUP Christian Colucci", url: "https://customer-assets.emergentagent.com/job_proposta-su-misura/artifacts/qvwx9ifz_Allegato%204-MUP_CHRISTIAN%20COLUCCI.pdf" },
  { label: "Allegato 4 - MUP Ciro Colucci", url: "https://customer-assets.emergentagent.com/job_proposta-su-misura/artifacts/or5tkns2_Allegato%204-MUP_CIRO%20COLUCCI.pdf" },
];

/**
 * Blocco consensi GDPR granulari (art. 13 GDPR + D.Lgs. 196/2003).
 * I consensi OBBLIGATORI (privacy contrattuale + MUP IVASS) sono separati dai
 * consensi FACOLTATIVI (marketing, profilazione), in linea con le Linee Guida
 * del Garante Privacy (provvedimento 15/2013, EDPB 2020).
 */
export default function DichiarazioniBlock({ formData, update }) {
  return (
    <div className="space-y-3" data-testid="dichiarazioni-block">
      {/* Informativa art. 13 GDPR */}
      <div className="p-3.5 bg-[#163321]/5 rounded-xl border border-[#163321]/10 text-[11px] text-[#4A5E51] leading-relaxed flex gap-2">
        <ShieldAlert className="w-4 h-4 text-[#163321] flex-shrink-0 mt-0.5" />
        <div>
          <p className="font-semibold text-[#163321] mb-1">Informativa sintetica (art. 13 GDPR)</p>
          <p>
            <strong>Titolare:</strong> Christian e Ciro Colucci S.A.S. — P.IVA 07618011212 — RUI A000464752.{" "}
            <strong>Finalità:</strong> gestione della richiesta di preventivo/consulenza e obblighi IVASS.{" "}
            <strong>Base giuridica:</strong> art. 6.1.b GDPR (misure precontrattuali) e art. 6.1.c GDPR (obblighi legali).{" "}
            <strong>Conservazione:</strong> 10 anni dopo ultimo contatto (IVASS + normativa antiriciclaggio).{" "}
            <strong>Diritti:</strong> accesso, rettifica, cancellazione, portabilità, opposizione, reclamo al Garante (garanteprivacy.it).{" "}
            Informativa completa su <Link to="/privacy" className="underline text-[#163321]">privacy policy</Link>.
          </p>
        </div>
      </div>

      {/* 1. Consenso PRIVACY (obbligatorio: senza non si può procedere) */}
      <div className="flex items-start gap-3 p-4 bg-[#F5F4F0] rounded-xl" data-testid="consenso-privacy">
        <Checkbox
          id="dichiarazioni-privacy"
          checked={formData.privacy || false}
          onCheckedChange={v => update("privacy", v)}
          className="mt-0.5 data-[state=checked]:bg-[#163321]"
          data-testid="privacy-checkbox"
        />
        <label htmlFor="dichiarazioni-privacy" className="text-xs text-[#4A5E51] leading-relaxed cursor-pointer">
          <strong>Privacy Policy</strong> <span className="text-[#D97B58]">* Obbligatorio</span><br />
          Ho letto e compreso la <Link to="/privacy" target="_blank" className="underline text-[#163321]">privacy policy</Link>. Acconsento al trattamento dei miei dati per la gestione della richiesta di preventivo/consulenza assicurativa.
        </label>
      </div>

      {/* 2. MUP IVASS (obbligatorio) */}
      <div className="flex items-start gap-3 p-4 bg-[#F5F4F0] rounded-xl" data-testid="consenso-mup">
        <Checkbox
          id="dichiarazioni-mup"
          checked={formData.mup || false}
          onCheckedChange={v => update("mup", v)}
          className="mt-0.5 data-[state=checked]:bg-[#163321]"
          data-testid="mup-checkbox"
        />
        <div>
          <label htmlFor="dichiarazioni-mup" className="text-xs text-[#4A5E51] leading-relaxed cursor-pointer block">
            <strong>MUP IVASS - Allegato 3 e 4</strong> <span className="text-[#D97B58]">* Obbligatorio</span><br />
            In ottemperanza al Provvedimento IVASS n. 147/2024, dichiaro di aver ricevuto e consultato copia dei Moduli Unici Precontrattuali (MUP) di Christian Colucci e Ciro Colucci.
          </label>
          <div className="mt-2.5 flex flex-wrap gap-2">
            {MUP_FILES.map((f, i) => (
              <a
                key={i}
                href={f.url}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-lg bg-white border border-[#E5E2DB] text-[10px] font-medium text-[#163321] hover:bg-[#163321]/5 hover:border-[#163321]/30 transition-all"
                data-testid={`mup-download-${i}`}
              >
                <Download className="w-3 h-3" /> {f.label}
              </a>
            ))}
          </div>
        </div>
      </div>

      {/* 3. Marketing (facoltativo) */}
      <div className="flex items-start gap-3 p-4 bg-white rounded-xl border border-[#E5E2DB]" data-testid="consenso-marketing">
        <Checkbox
          id="dichiarazioni-marketing"
          checked={formData.marketing || false}
          onCheckedChange={v => update("marketing", v)}
          className="mt-0.5 data-[state=checked]:bg-[#163321]"
          data-testid="marketing-checkbox"
        />
        <label htmlFor="dichiarazioni-marketing" className="text-xs text-[#4A5E51] leading-relaxed cursor-pointer">
          <strong>Comunicazioni commerciali</strong> <span className="text-[#4A5E51]/60">(facoltativo)</span><br />
          Acconsento al trattamento dei miei dati per ricevere comunicazioni commerciali, newsletter e offerte su prodotti assicurativi e di noleggio tramite email/SMS/WhatsApp. Posso revocare il consenso in qualsiasi momento.
        </label>
      </div>

      {/* 4. Profilazione (facoltativo) */}
      <div className="flex items-start gap-3 p-4 bg-white rounded-xl border border-[#E5E2DB]" data-testid="consenso-profilazione">
        <Checkbox
          id="dichiarazioni-profilazione"
          checked={formData.profilazione || false}
          onCheckedChange={v => update("profilazione", v)}
          className="mt-0.5 data-[state=checked]:bg-[#163321]"
          data-testid="profilazione-checkbox"
        />
        <label htmlFor="dichiarazioni-profilazione" className="text-xs text-[#4A5E51] leading-relaxed cursor-pointer">
          <strong>Analisi e profilazione</strong> <span className="text-[#4A5E51]/60">(facoltativo)</span><br />
          Acconsento all'analisi dei miei dati per proposte assicurative personalizzate sulla base del mio profilo (necessità, storico, preferenze). Nessuna decisione automatizzata rilevante ex art. 22 GDPR.
        </label>
      </div>
    </div>
  );
}
